import React from 'react';
import LocationTemplate from './LocationTemplate';

const AshevillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Asheville"
      stateName="North Carolina"
      countyName="Buncombe"
      zipCodes={["28801", "28802", "28803", "28804", "28805", "28806", "28810", "28813", "28814", "28815", "28816"]}
      latitude={35.5951}
      longitude={-82.5515}
      population={94589}
      historicalFact="Located in the Blue Ridge Mountains, known for its arts scene and the historic Biltmore Estate."
      nearbyTowns={[
        "Black Mountain, NC",
        "Hendersonville, NC",
        "Waynesville, NC",
        "Boone, NC",
        "Brevard, NC",
        "Weaverville, NC",
        "Fletcher, NC",
        "Woodfin, NC"
      ]}
    />
  );
};

export default AshevillePage;